var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 530.97 551.99",
    style: {
      enableBackground: "new 0 0 530.97 551.99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M263.3,17.44C122.32,17.44,8,131.75,8,272.77c0,112.79,73.15,208.49,174.61,242.25 c12.77,2.34,17.43-5.54,17.43-12.31c0-6.06-0.22-22.12-0.34-43.42c-71.02,15.43-86.01-34.22-86.01-34.22 c-11.61-29.49-28.35-37.35-28.35-37.35c-23.18-15.84,1.75-15.52,1.75-15.52c25.62,1.81,39.11,26.31,39.11,26.31 c22.78,39.02,59.76,27.75,74.3,21.21c2.32-16.5,8.92-27.75,16.21-34.13c-56.69-6.44-116.3-28.35-116.3-126.18 c0-27.87,9.95-50.66,26.28-68.51c-2.63-6.46-11.39-32.42,2.5-67.57c0,0,21.44-6.87,70.21,26.17c20.36-5.66,42.21-8.5,63.92-8.59 c21.68,0.1,43.52,2.93,63.92,8.59c48.74-33.04,70.14-26.17,70.14-26.17c13.93,35.15,5.17,61.11,2.54,67.57 c16.36,17.85,26.24,40.64,26.24,68.51c0,98.08-59.69,119.66-116.57,125.99c9.17,7.88,17.33,23.46,17.33,47.28 c0,34.13-0.31,61.67-0.31,70.04c0,6.83,4.6,14.77,17.56,12.28c101.37-33.83,174.45-129.46,174.45-242.22 C518.63,131.75,404.31,17.44,263.3,17.44z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.48f62523d5e56357e0a658639fb1876b.svg";
export { ForwardRef as ReactComponent };